import React from 'react';

import { MortgageLegal } from '@templates/Legal';
import { propsWithWrappers } from '@utils/getServerSideProps/propsWithWrappers';

const LegalPage: React.FC = () => {
  return <MortgageLegal />;
};

export const getServerSideProps = propsWithWrappers();

export default LegalPage;
